import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./firebase-config";

// Ask user permission and get FCM token
export async function requestPermission() {
  try {
    const token = await getToken(messaging, {
      vapidKey: "BGfbQT4pdHqMQcav0g1hc8_C_66iC7mqM8SFZzqN4zkryFARSjNmhf4LpTmJQpqnG_ShOWFuCGzGUla2EEZXL9Q", // ✅ your public VAPID key
    });
    return token;
  } catch (err) {
    console.error("❌ Permission denied or error getting token:", err);
    return null;
  }
}

// Foreground notification handler
export function listenForMessages(callback) {
  onMessage(messaging, (payload) => {
    console.log("📩 Foreground message received:", payload);
    if (callback) callback(payload);
  });
}
